import { render, staticRenderFns } from "./PostingDetailAmenities.vue?vue&type=template&id=9d97842e&"
import script from "./PostingDetailAmenities.vue?vue&type=script&lang=js&"
export * from "./PostingDetailAmenities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports